import { FC } from "react";
import { CashQueryFormProps } from "./types";
import { Row } from "../../containers";
import { DateInput, NumberInput, SelectorInput, TextInput } from "../../inputs";
import { CashType, Customer } from "../../../types";
import { useGeneralStore } from "../../../stores";
import { CASH_TYPE_LIST } from "../../../constants/misc";

const CashQueryForm: FC<CashQueryFormProps> = ({
  cashQuery,
  setCustomer,
  setDescription,
  setTotalPrice,
  setType,
  setFromDate,
  setToDate,
  readOnly = false,
}) => {
  const customers = useGeneralStore((s) => s.customers);

  return (
    <>
      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        <SelectorInput<Customer>
          items={customers}
          uniqueKey={"fullname"}
          selected={cashQuery.customer}
          setSelected={setCustomer || (() => {})}
          stringField={"fullname"}
          renderStrings={["fullname", "phone"]}
          compareFn={(c, v) =>
            c.fullname.toLowerCase().includes(v.toLowerCase()) ||
            c.phone.includes(v)
          }
          label="نام مشتری"
          readOnly={readOnly}
        />

        <TextInput
          label="بابت"
          value={cashQuery.description}
          setValue={setDescription}
          inputProps={{ readOnly }}
        />

        <NumberInput
          label="مبلغ کل (ریال)"
          value={cashQuery.total_price}
          setValue={setTotalPrice || (() => {})}
          inputProps={{ readOnly }}
          price
        />
      </Row>

      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        <DateInput
          date={cashQuery.fromDate}
          label="از تاریخ"
          setDate={setFromDate || (() => {})}
          readOnly={readOnly}
        />

        <DateInput
          date={cashQuery.toDate}
          label="تا تاریخ"
          setDate={setToDate || (() => {})}
          readOnly={readOnly}
        />

        <SelectorInput<CashType>
          items={CASH_TYPE_LIST}
          uniqueKey={"name"}
          selected={cashQuery.type}
          setSelected={setType || (() => {})}
          stringField={"fa"}
          renderStrings={["fa"]}
          compareFn={(t, v) => t.fa.toLowerCase().includes(v.toLowerCase())}
          label="نوع نقدی"
          readOnly={readOnly}
        />
      </Row>
    </>
  );
};

export default CashQueryForm;
